import { render, staticRenderFns } from "./db-state-badge.vue?vue&type=template&id=cf50ebb0&"
import script from "./db-state-badge.vue?vue&type=script&lang=js&"
export * from "./db-state-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports